import { useContext } from "react";
import styles from "./Footer.module.css"
import Context from "../../Context";
import { uniqueId } from "lodash";
import { MenuItemsT, MenuT, SociaisT } from "../../interfaces";
import { Link } from "react-router-dom";

import FW2Icon from "./logo.svg";

const Footer = () => {
    const { imagens, resumo, textos } = useContext(Context);
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.flex}>
                    <div className={styles.fixedWidth}>
                        <img src={imagens.logo_white.large} alt={resumo.configuracoes.app_title} />
                        <div className={styles.social}>
                            {resumo?.sociais && resumo?.sociais.length > 0 ? resumo?.sociais.map((social: SociaisT) => {
                                return (
                                    <a key={uniqueId("sociais_")} href={social.link} title={social.nome} rel="noopener noreferrer" target="_blank">
                                        <img src={social.dark.large} alt={social.nome} />
                                    </a>
                                );
                            })
                                : <></>
                            }
                        </div>
                    </div>
                    <div className={styles.menus}>
                        <div>
                            <h3>Menu</h3>
                            {resumo?.menus.filter((obj: MenuT) => obj.nome === "Footer").map((menu: MenuT) => {
                                return (<div key={uniqueId("menu_wrapper_")} className={styles.menu}>
                                    {menu.related.menu_items.map((item: MenuItemsT) => {
                                        if (parseInt(item.externo) === 1) {
                                            return <a key={uniqueId("menu_")} className={parseInt(item.button) === 1 ? styles.menu_button : ''} href={item.link} title={item.nome} target={"_blank"} rel="noopener noreferrer">
                                                <span>{item.nome}</span>
                                            </a>
                                        } else {
                                            return <Link key={uniqueId("menu_")} className={parseInt(item.button) === 1 ? styles.menu_button : ''} to={item.link} title={item.nome}>
                                                <span>{item.nome}</span>
                                            </Link>
                                        }
                                    })}
                                </div>
                                );
                            })}
                        </div>
                        <div>
                            <h3>Links</h3>
                            {resumo?.menus.filter((obj: MenuT) => obj.nome === "Links").map((menu: MenuT) => {
                                return (<div key={uniqueId("menu_wrapper_")} className={styles.menu}>
                                    {menu.related.menu_items.map((item: MenuItemsT) => {
                                        if (parseInt(item.externo) === 1) {
                                            return <a key={uniqueId("menu_")} className={parseInt(item.button) === 1 ? styles.menu_button : ''} href={item.link} title={item.nome} target={"_blank"} rel="noopener noreferrer">
                                                <span>{item.nome}</span>
                                            </a>
                                        } else {
                                            return <Link key={uniqueId("menu_")} className={parseInt(item.button) === 1 ? styles.menu_button : ''} to={item.link} title={item.nome}>
                                                <span>{item.nome}</span>
                                            </Link>
                                        }
                                    })}
                                </div>
                                );
                            })}
                        </div>
                        <div>
                            <h3>Contato</h3>
                            <div className={styles.contato} dangerouslySetInnerHTML={{ __html: textos.footer_contato }}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.container}>
                <div className={styles.creditos}>
                    <p>{resumo.configuracoes.empresa} - {resumo.configuracoes.cnpj && resumo.configuracoes.cnpj.length > 1 ? `${resumo.configuracoes.cnpj} - ` : ""} Todos os direitos reservados © {new Date().getFullYear()}</p>
                    <a href="https://fw2propaganda.com.br/" target="_blank" rel="noopener noreferrer" title="Desenvolvido por Gustavo Barbosa">Site desenvolvido por <img src={FW2Icon} alt="FW2 Propaganda" /></a>
                </div>
            </div>
        </div>
    )
}

export default Footer;